namespace RioERP.Masters {
    export interface PendriveTypesRow {
        Id?: number;
        PendriveType?: string;
    }

    export namespace PendriveTypesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PendriveType';
        export const localTextPrefix = 'Masters.PendriveTypes';
        export const lookupKey = 'Masters.PendriveTypes';

        export function getLookup(): Q.Lookup<PendriveTypesRow> {
            return Q.getLookup<PendriveTypesRow>('Masters.PendriveTypes');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            PendriveType = "PendriveType"
        }
    }
}
